const tableHeaders = [
  {
    label: 'Report Month',
    key: 'period',
    defaultSort: true,
    sortable: false,
    sortReverse: 'desc',
  },
  {
    label: 'Date',
    key: 'letterDate',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Letter',
    key: 'infractionName',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Surveys',
    key: 'totalSurveys',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Acknowledged',
    key: 'acknowledgementDate',
    defaultSort: true,
    sortable: false,
    filter: 'date',
  },
  {
    label: 'Appeal Status',
    key: 'stage',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Submitted',
    key: 'submitted',
    sortable: false,
  },
  {
    label: 'Approved/Switched',
    key: 'approved',
    sortable: false,
  },
  {
    label: 'Denied',
    key: 'denied',
    sortable: false,
  },
  {
    label: 'Open',
    key: 'open',
    sortable: false,
  },
];

export default () => tableHeaders;
